namespace GeniuzPOS.Product {
    export class CsStyleColumns {
        static columnsKey = 'Product.CsStyle';
    }
}
